interface ILotesIconProps {
  color: string;
}

export const LotesIcon: React.FC<ILotesIconProps> = ({ color }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2293_6194)">
        <path
          d="M7 6.5V3.5C7 3.23478 7.10536 2.98043 7.29289 2.79289C7.48043 2.60536 7.73478 2.5 8 2.5H20C20.2652 2.5 20.5196 2.60536 20.7071 2.79289C20.8946 2.98043 21 3.23478 21 3.5V17.5C21 17.7652 20.8946 18.0196 20.7071 18.2071C20.5196 18.3946 20.2652 18.5 20 18.5H17V21.5C17 22.052 16.55 22.5 15.993 22.5H4.007C3.87513 22.5008 3.7444 22.4755 3.62232 22.4256C3.50025 22.3757 3.38923 22.3022 3.29566 22.2093C3.20208 22.1164 3.12779 22.0059 3.07705 21.8841C3.02632 21.7624 3.00013 21.6319 3 21.5L3.003 7.5C3.003 6.948 3.453 6.5 4.009 6.5H7ZM5.002 8.5L5 20.5H15V8.5H5.002ZM9 6.5H17V16.5H19V4.5H9V6.5ZM7 11.5H13V13.5H7V11.5ZM7 15.5H13V17.5H7V15.5Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_2293_6194">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
